"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CONSTS = void 0;
const CONSTS = exports.CONSTS = Object.freeze({
  // アクション名のプロジェクト共通接頭辞
  COMMON_ACTION_PREFIX: 'notice',
  // 画面遷移用コンテンツ
  CONTENTS: {
    HISTORY: 'history',
    // 履歴
    DETAIL: 'detail',
    // 詳細
    REGIST_ENTRY: 'registEntry',
    // 登録
    REGIST_RESULT: 'registResult',
    // 登録結果
    UPDATE_ENTRY: 'updateEntry',
    // 更新
    UPDATE_RESULT: 'updateResult',
    // 更新結果
    HOME: 'home',
    // ホーム
    MENU: 'menu' // メニュー
  }
});